<template>
  <VDialog
    v-model="_dialog"
    persistent
    max-width="600px"
  >
    <VCard
      height="500"
    >
      <VToolbar
        dark
        color="primary"
      >
        <VToolbarTitle>Schedule Messages</VToolbarTitle>
      </VToolbar>
      <VCardText>
        <VLayout
          column
          fill-height
          justify-space-between
        >
          <VFlex
            xs12
          >
            <VForm
              ref="form"
              v-model="valid"
            >
              <VLayout
                column
                fill-height
                align-space-around
                justify-space-between
              >
                <VFlex
                  xs2
                >
                  <VCardTitle
                    pa-0
                  >
                    <span>
                      You are sending more than {{ maxOneTimeMassMessages }} messages at one time.
                      Please select a time frame to schedule all your messages.
                    </span>
                  </VCardTitle>
                </VFlex>
                <VFlex
                  xs9
                >
                  <VCardText>
                    <VContainer
                      grid-list-md
                      ma-0
                      pa-0
                    >
                      <VLayout
                        row
                        wrap
                        fill-height
                      >
                        <VFlex
                          xs12
                          sm6
                        >
                          <VueCtkDateTimePicker
                            v-model="startTime"
                            input-size="lg"
                            minute-interval="10"
                            only-time
                            no-header
                            no-shortcuts
                            overlay
                            color="green"
                            label="Select Start Time"
                            format="hh:mm a"
                            formatted="hh:mm a"
                            minute-interavl="10"
                          />
                        </VFlex>
                        <VFlex
                          xs12
                          sm6
                        >
                          <VueCtkDateTimePicker
                            v-model="endTime"
                            input-size="lg"
                            minute-interval="10"
                            only-time
                            no-header
                            no-shortcuts
                            overlay
                            color="firebrick"
                            label="Select End Time"
                            format="hh:mm a"
                            formatted="hh:mm a"
                            minute-interavl="10"
                          />
                        </VFlex>
                        <VFlex
                          xs12
                        >
                          <VAutocomplete
                            v-model="selectedTimeZone"
                            chips
                            clearable
                            :items="items"
                            :rules="rules.required"
                            label="Time Zone*"
                          />
                        </VFlex>
                      </VLayout>
                    </VContainer>
                  </VCardText>
                </VFlex>
                <VFlex
                  xs1
                >
                  <VAlert
                    :value="!isValidTimeFrame()"
                    type="warning"
                  >
                    Start Time should be smaller than End Time
                  </VAlert>
                </VFlex>
              </VLayout>
            </VForm>
          </VFlex>
          <VFlex
            xs12
          >
            <div class="card-actions">
              <VCardActions>
                <VSpacer />
                <VBtn
                  color="blue darken-1"
                  flat
                  @click="_dialog = false"
                >
                  Close
                </VBtn>
                <VBtn
                  color="blue darken-1"
                  flat
                  :disabled="!valid || !isValidTimeFrame()"
                  @click="onSubmitClicked"
                >
                  Submit
                </VBtn>
              </VCardActions>
            </div>
          </VFlex>
        </VLayout>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import moment from 'moment-timezone'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  name: 'TimeFrameDialog',
  components: { VueCtkDateTimePicker },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    maxOneTimeMassMessages: {
      type: Number,
      default: 500
    }
  },
  data: function () {
    return {
      selectedTimeZone: moment.tz.guess(),
      items: moment.tz.names(),
      startTime: new Date().toLocaleTimeString(),
      endTime: new Date().toLocaleTimeString(),
      valid: false,
      rules: {
        required: [value => !!value || 'Required.'
        ]
      }
    }
  },
  computed: {
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  watch: {
    startTime: function () {
      this.isValidTimeFrame()
    },
    endTime: function () {
      this.isValidTimeFrame()
    }
  },
  methods: {
    isValidDate (d) {
      return d instanceof Date && !isNaN(d)
    },
    isValidTimeFrame () {
      const dateString = new Date().toDateString()
      let start = new Date(this.startTime)
      if (!this.isValidDate(start)) {
        start = new Date(`${dateString}, ${this.startTime}`)
      }
      let end = new Date(this.endTime)
      if (!this.isValidDate(end)) {
        end = new Date(`${dateString}, ${this.endTime}`)
      }
      return start < end
    },
    onSubmitClicked () {
      this._dialog = false
      this.$emit('submitClicked',
        { startTime: this.startTime, endTime: this.endTime, timeZone: this.selectedTimeZone })
    }
  }
}
</script>

<style scoped>
  .card-actions {
    position: absolute;
    right: 0;
    bottom: 0;
  }
</style>
